import React, { useRef } from "react";
import Card from "./card";
import work1 from "../assets/work1.jpg";
import work3 from "../assets/work2.jpg";
import work2 from "../assets/work3.jpg";
import png3 from "../assets/PNG_3.png";
import "./ItWork.css"; // Import the CSS file

export default function ItWork() {
  const itWorkRef = useRef(null);

  const cardData = [
    {
      image: work1,
      title: "Step1: ⁠Hold and Earn Rewards:",
      description:
        "Join a vibrant and supportive community where your voice matters. Participate in events, collaborations, and decisions shaping the future of Cinnamoroll.",
    },
    {
      image: work3,
      title: "Step2: ⁠⁠Community Engagement:",
      description:
        "Now that you’ve got $PPP, you’re officially part of the cult. Brag to your friends that you own the cutest coin ever.",
    },
    {
      image: work2,
      title: "Step3: Grow with Us:",
      description:
        "Watch your holdings grow as we expand and bring new opportunities through innovative partnerships  and  projects.",
    },
  ];

  return (
    <div ref={itWorkRef} className="itwork-container">
      {/* Logo positioned top-right */}
      <div className="itwork-logo">
        <img src={png3} alt="logo" width={100} height={100} />
      </div>

      {/* Content Section */}
      <div className="itwork-content">
        <div className="mb-4">
          <h2 className="title">How It Works</h2>
          <h4 className="subtitle">
            Learn more about how our solution can help you achieve your goals.
          </h4>
        </div>

        {/* Cards Section */}
        <div className="cards-section">
          <div className="cards-row">
            {cardData.map((card, index) => (
              <div
                key={index}
                className="card-wrapper animate"
                style={{
                  animationDelay: `${index * 0.3}s`,
                }}
              >
                <Card
                  image={card.image}
                  title={card.title}
                  description={card.description}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
